<div class="login-choice">
  <div class="login">
    <kp-login-header></kp-login-header>
    <div class="login-choice">
      <a
        routerLink="/login/email"
        [queryParams]="{ redirectUrl: redirectUrl }"
        [replaceUrl]="true"
        class="button button-pill"
        [ngClass]="{ disabled: loginDisabled }">
        Sign in with Email
      </a>
      <div class="separator"><span class="separator-copy">or</span></div>
      <h2 class="login-instructions-sso">Sign in with:</h2>
      <div class="button-container">
        <button
          type="button"
          class="button button-pill button-sso button-sso-apple"
          [disabled]="loginDisabled"
          (click)="ssoLogin(socialSso.SignInWithApple)"
          aria-label="Sign in with Apple">
          <svg-icon class="button-sso-logo" src="/assets/icons/logo-Apple-black.svg"></svg-icon>
        </button>
        <button
          type="button"
          class="button button-pill button-sso button-sso-google"
          [disabled]="loginDisabled"
          (click)="ssoLogin(socialSso.Google)"
          aria-label="Sign in with Google">
          <svg-icon class="button-sso-logo" src="/assets/icons/logo-Google-superG.svg"></svg-icon>
        </button>
      </div>
      <p class="login-instructions">
        Need to create your Kumanu account? Follow the link provided by Kumanu or your sponsoring organization.
      </p>
    </div>
  </div>
</div>
